'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import getCookies from 'commons/getCookies';
import SuspenseWithLoader from '../SuspenseWithLoader';
import ProductListingPagePlaceholder from '../ProductListingPage/ProductListingPagePlaceholder';
import CategoryPageLegacy from './CategoryPageLegacy';
import CategoryPageAlgolia from '../category-page-algolia';
const COOKIE_KEY = 'use-new-category-page';
const stripLeadingAndTrailingSlash = path => {
  const pathWithoutLeadingSlash = path.startsWith('/') ? path.slice(1) : path;
  const pathWithoutTrailingSlash = pathWithoutLeadingSlash.endsWith('/') ? pathWithoutLeadingSlash.slice(0, -1) : pathWithoutLeadingSlash;
  return pathWithoutTrailingSlash;
};
const CategoryPage = t0 => {
  const $ = _c(13);
  const {
    sidebarHeader,
    serverCategoryData
  } = t0;
  const location = useLocation();
  const pathname = location?.pathname || "";
  let t1;
  if ($[0] !== pathname) {
    t1 = stripLeadingAndTrailingSlash(pathname);
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const slug = t1;
  const [useAlgolia, setUseAlgolia] = useState(false);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const value = getCookies()?.get(COOKIE_KEY);
      if (value && String(value).trim() === "true") {
        setUseAlgolia(true);
      }
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ProductListingPagePlaceholder />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== serverCategoryData || $[6] !== sidebarHeader || $[7] !== slug || $[8] !== useAlgolia) {
    t5 = useAlgolia ? <CategoryPageAlgolia key={slug} slug={slug} serverCategoryData={serverCategoryData} /> : <CategoryPageLegacy key={slug} sidebarHeader={sidebarHeader} slug={slug} serverCategoryData={serverCategoryData} />;
    $[5] = serverCategoryData;
    $[6] = sidebarHeader;
    $[7] = slug;
    $[8] = useAlgolia;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== slug || $[11] !== t5) {
    t6 = <SuspenseWithLoader fallback={t4} key={slug}>{t5}</SuspenseWithLoader>;
    $[10] = slug;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
CategoryPage.propTypes = {
  sidebarHeader: PropTypes.node,
  serverCategoryData: PropTypes.object
};
export default CategoryPage;